export enum EffectivenessPageType {
    NotStarted = 0,
    UploadSourceDocuments = 1,
    GenerateSamples = 2,
    UploadEvidence = 3,
    Test = 4,
    Review = 5,
    Completed = 6,
}
